import type { AgentV2Message, AgentV2MessageAttachedFiles } from '@/agent-v2/store/reducer'

/**
 * The files each user message newly attached. Every turn sends the conversation's whole file selection, so a
 * turn's own files are the ones its predecessor did not have.
 */
export function getTurnAddedFilesByMessageId(messages: AgentV2Message[]): Record<string, AgentV2MessageAttachedFiles> {
  const addedFilesByMessageId: Record<string, AgentV2MessageAttachedFiles> = {}
  let previous: AgentV2MessageAttachedFiles | null = null

  for (const message of messages) {
    // A message whose files are not known yet is skipped, so it is never mistaken for a turn that dropped them all
    if (message.role !== 'user' || !message.attachedFiles) continue

    const { fileIds, writingSampleFileId } = message.attachedFiles
    const previousFileIds = new Set(previous?.fileIds ?? [])
    const addedFileIds = fileIds.filter((fileId) => !previousFileIds.has(fileId))
    const addedWritingSampleFileId = writingSampleFileId !== previous?.writingSampleFileId ? writingSampleFileId : null

    // Persisted turns know their true predecessor even at a page boundary. Live messages
    // use the loaded previous selection until history supplies the durable result.
    const addedFiles = message.addedFiles ?? { fileIds: addedFileIds, writingSampleFileId: addedWritingSampleFileId }
    if (addedFiles.fileIds.length > 0 || addedFiles.writingSampleFileId) {
      addedFilesByMessageId[message.id] = addedFiles
    }
    previous = message.attachedFiles
  }

  return addedFilesByMessageId
}
